import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
export const Title = _ref => {
  let {
    app,
    instance
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-title",
    className: "jsx-2721515324"
  }, app ? "".concat(instance, " - ").concat(app) : "".concat(instance), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2721515324"
  }, ["div.jsx-2721515324{overflow:hidden;text-overflow:ellipsis;font-size:14px;font-weight:500;-webkit-letter-spacing:0.01em;-moz-letter-spacing:0.01em;-ms-letter-spacing:0.01em;letter-spacing:0.01em;white-space:nowrap;}"]));
};
Title.propTypes = {
  app: PropTypes.string,
  instance: PropTypes.string
};